import { NavBar } from '../components/NavBar'

export const NotFoundPage = () => {
  return (
    <div className={'min-h-screen flex flex-col bg-background'}>
      <NavBar />
      <div className={'flex-1 flex items-center justify-center'}>
        <div className={'md:text-2xl text-xl text-center px-4'}>
          Page not found
        </div>
      </div>
    </div>
  )
}
